import { InternalOrganizationBillingDetailsType } from '@/api/v1/organization/internal/getInternalOrganizationBillingDetailsApi';
import { getBuyOverageWiresPath } from '@/bundle/_MasterAdmin/_BuyOverageWiresPage/path/path';
import { useSubscriptionStatus } from '@/bundle/shared/hooks/useSubscriptionStatus';
import { Box } from '@/components/Box/Box';
import { Button } from '@/components/Button/Button';
import { ProgressBar } from '@/components/ProgressBar/ProgressBar';
import { useStatefulNavigation } from '@/hooks/useStatefulNavigation';

type OverageWiresUsageRowType = {
  billingDetails: InternalOrganizationBillingDetailsType;
};

export const OverageWiresUsageRow = ({ billingDetails }: OverageWiresUsageRowType) => {
  const { navigateFrom } = useStatefulNavigation();
  const { isSuspendedSubscription } = useSubscriptionStatus();

  const { extra_views_available, extra_views_bought, monthly_views_available } = billingDetails;
  const isDisabled = !!monthly_views_available || isSuspendedSubscription;

  return (
    <Box width='100%' display='flex' alignItems='center' columnGap='16px'>
      <ProgressBar
        label='Overage Wires'
        count={extra_views_bought - extra_views_available}
        totalCount={extra_views_bought}
      />
      <Box flexShrink={0}>
        <Button
          size='medium'
          onClick={() => navigateFrom(getBuyOverageWiresPath())}
          mobileStretch
          width='110px'
          disabled={isDisabled}
        >
          Buy More
        </Button>
      </Box>
    </Box>
  );
};
